import React from "react";
import "./styles.css";

import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

import Home from "./components/Home/Home";

const App = () => {
  return (
    <div className="appContainer">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/marketing-digital" element={<Navigate to="/#servicios" replace />} />
          <Route path="/marketing-externo" element={<Navigate to="/#marketing-externo" replace />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
};

export default App;
